import { render } from "./EstimatorCloning.vue?vue&type=template&id=6510ec56&scoped=true&ts=true"
import script from "./EstimatorCloning.vue?vue&type=script&lang=ts"
export * from "./EstimatorCloning.vue?vue&type=script&lang=ts"

import "./EstimatorCloning.vue?vue&type=style&index=0&id=6510ec56&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6510ec56"]])

export default __exports__